var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.expired)?_c('expired-purchaser-token'):_vm._e(),(_vm.uri_enc.length > 2 && !_vm.expired)?_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(decodeURI(_vm.uri_enc))}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }